import { DoodleIcon } from '../DoodleIcon';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { sectionArtwork } from '../../data/courseSectionVisuals';
import { CourseSectionArtwork } from './CourseSectionArtwork';

export const SkillsSection = ({ outcomes = [], category }) => {
  const [headingRef, isVisible] = useScrollAnimation();
  if (!outcomes.length) return null;
  const art = category === 'Искусственный интеллект' ? sectionArtwork.ai
    : ['Веб разработка', 'CMS и Конструкторы'].includes(category) ? sectionArtwork.developer
    : sectionArtwork.creative;
  return <section className="editorial-section course-outcomes" data-testid="skills-section"><div className="editorial-container">
    <div ref={headingRef} className={`course-section-reveal ${isVisible ? 'is-visible' : ''}`}>
      <p className="course-eyebrow">На практике</p>
      <h2>Чему вы <span className="ink-underline">научитесь</span></h2>
    </div>
    <div className="course-outcomes-layout">
    <div className="course-outcome-grid">{outcomes.map((item, index) => <article key={item.name} className="course-outcome-card">
      <span className="course-outcome-number">{String(index + 1).padStart(2, '0')}</span>
      <div><h3>{item.name}</h3><p>{item.description}</p></div><DoodleIcon name="tick" size={24}/>
    </article>)}</div>
    <CourseSectionArtwork art={art} />
    </div>
  </div></section>;
};
